"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reduxForm = require("redux-form");

var _getHeightInCentimetres = _interopRequireDefault(require("../../../utils/getHeightInCentimetres"));

var _FieldDescription = _interopRequireDefault(require("../../../ui/FieldDescription"));

var _FieldLabel = _interopRequireDefault(require("../../../ui/FieldLabel"));

var _FieldTitle = _interopRequireDefault(require("../../../ui/FieldTitle"));

var _keyHelpers = require("../../../utils/keyHelpers");

var _index = require("../../../types/index");

var _heightWeightConfig = require("../heightWeightConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var HTMLSelectEvent = _flowRuntime["default"].tdz(function () {
  return _index.HTMLSelectEvent;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _index.FieldElementDefinition;
});

var FieldProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FieldProps;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("height", _flowRuntime["default"].ref(FieldElementDefinition))));

var RenderProps = _flowRuntime["default"].type("RenderProps", _flowRuntime["default"].intersection(Props, _flowRuntime["default"].ref(FieldProps)));

var State = _flowRuntime["default"].type("State", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("heightUnit", _flowRuntime["default"].union(_flowRuntime["default"].string("metric"), _flowRuntime["default"].string("imperial"))), _flowRuntime["default"].property("heightMetricValue", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("heightFeetValue", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("heightInchesValue", _flowRuntime["default"].string(), true)));

var HeightSelectFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HeightSelectFields, _React$Component);

  var _super = (0, _createSuper2["default"])(HeightSelectFields);

  function HeightSelectFields(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, HeightSelectFields);
    _this = _super.call(this, props);

    _this.handleHeightUnitChange = function (e) {
      _this.setState({
        heightUnit: e.target.value === 'metric' ? 'metric' : 'imperial'
      });
    };

    _this.heightMetricChange = function (e) {
      var onBlur = _this.props.input.onBlur;

      _this.setState({
        heightMetricValue: e.target.value
      });

      onBlur();
    };

    _this.heightFeetChange = function (e) {
      var onBlur = _this.props.input.onBlur;

      _this.setState({
        heightFeetValue: e.target.value
      });

      if (_this.state.heightInchesValue) {
        onBlur();

        _this.setState({
          heightMetricValue: undefined
        });
      }
    };

    _this.heightInchesChange = function (e) {
      var onBlur = _this.props.input.onBlur;

      _this.setState({
        heightInchesValue: e.target.value
      });

      if (_this.state.heightFeetValue) {
        onBlur();

        _this.setState({
          heightMetricValue: undefined
        });
      }
    };

    _this.state = {
      heightFeetValue: undefined,
      heightInchesValue: undefined,
      heightMetricValue: undefined,
      heightUnit: 'metric'
    };
    return _this;
  }

  (0, _createClass2["default"])(HeightSelectFields, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var onChange = this.props.input.onChange;
      var _this$state = this.state,
          heightFeetValue = _this$state.heightFeetValue,
          heightInchesValue = _this$state.heightInchesValue,
          heightMetricValue = _this$state.heightMetricValue;

      if (heightMetricValue) {
        onChange(heightMetricValue);
      } else if (heightFeetValue && heightInchesValue) {
        onChange((0, _getHeightInCentimetres["default"])(heightFeetValue, heightInchesValue));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          componentKey = _this$props.componentKey,
          height = _this$props.height,
          input = _this$props.input,
          _this$props$meta = _this$props.meta,
          touched = _this$props$meta.touched,
          error = _this$props$meta.error,
          warning = _this$props$meta.warning;
      var _this$state2 = this.state,
          heightFeetValue = _this$state2.heightFeetValue,
          heightInchesValue = _this$state2.heightInchesValue,
          heightMetricValue = _this$state2.heightMetricValue;

      var controlClass = function controlClass(ui) {
        return (0, _classnames["default"])('control control--radio', {
          bordered: ui && ui.border,
          'control--small': ui && ui.classes !== 'large'
        });
      };

      var indicatorClass = function indicatorClass(ui) {
        return (0, _classnames["default"])('control__indicator', {
          'control__indicator--small': ui && ui.classes !== 'large'
        });
      };

      var heightUnitKey = (0, _keyHelpers.compositeKey)(componentKey, _heightWeightConfig.heightUnit.key);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FieldTitle["default"], {
        field: height,
        isRequired: true
      }), /*#__PURE__*/React.createElement(_FieldDescription["default"], {
        field: height,
        position: "before"
      }), /*#__PURE__*/React.createElement(_FieldLabel["default"], {
        field: height
      }), /*#__PURE__*/React.createElement("div", null, _heightWeightConfig.heightUnit.items && _heightWeightConfig.heightUnit.items.map(function (item) {
        return /*#__PURE__*/React.createElement("label", {
          key: item.key,
          htmlFor: "".concat(heightUnitKey, ".").concat(item.key),
          className: controlClass(_heightWeightConfig.heightUnit.ui)
        }, /*#__PURE__*/React.createElement("input", {
          id: "".concat(heightUnitKey, ".").concat(item.key),
          name: heightUnitKey,
          type: "radio",
          value: item.value || item.key,
          onChange: _this2.handleHeightUnitChange,
          checked: item.key === _this2.state.heightUnit,
          className: indicatorClass(_heightWeightConfig.heightUnit.ui)
        }), /*#__PURE__*/React.createElement("span", null, item.label));
      })), this.state.heightUnit === 'metric' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        className: _heightWeightConfig.heightMetric && _heightWeightConfig.heightMetric.ui && _heightWeightConfig.heightMetric.ui.classes,
        htmlFor: _heightWeightConfig.heightMetric && "".concat(componentKey, ".").concat(_heightWeightConfig.heightMetric.key)
      }, /*#__PURE__*/React.createElement("select", {
        className: touched && error ? 'error' : null,
        id: _heightWeightConfig.heightMetric && "".concat(componentKey, ".").concat(_heightWeightConfig.heightMetric.key),
        onChange: this.heightMetricChange
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, input.value || _heightWeightConfig.heightMetric.placeholder || _heightWeightConfig.heightMetric.label || 'Select'), _heightWeightConfig.heightMetric && _heightWeightConfig.heightMetric.items && _heightWeightConfig.heightMetric.items.map(function (item) {
        return /*#__PURE__*/React.createElement("option", {
          key: item.key,
          value: item.value || item.key
        }, item.label);
      }))), heightMetricValue && /*#__PURE__*/React.createElement("div", {
        className: "col span_4_of_12 height-indicator"
      }, heightMetricValue, " cm")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        className: _heightWeightConfig.heightFeet && _heightWeightConfig.heightFeet.ui && _heightWeightConfig.heightFeet.ui.classes,
        htmlFor: _heightWeightConfig.heightFeet && "".concat(componentKey, ".").concat(_heightWeightConfig.heightFeet.key)
      }, /*#__PURE__*/React.createElement("select", {
        className: touched && error ? 'error' : null,
        id: _heightWeightConfig.heightFeet && "".concat(componentKey, ".").concat(_heightWeightConfig.heightFeet.key),
        onChange: this.heightFeetChange
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, _heightWeightConfig.heightFeet.placeholder || _heightWeightConfig.heightFeet.label || 'Select'), _heightWeightConfig.heightFeet && _heightWeightConfig.heightFeet.items && _heightWeightConfig.heightFeet.items.map(function (item) {
        return /*#__PURE__*/React.createElement("option", {
          key: item.key,
          value: item.value || item.key
        }, item.label);
      }))), /*#__PURE__*/React.createElement("label", {
        className: _heightWeightConfig.heightInches && _heightWeightConfig.heightInches.ui && _heightWeightConfig.heightInches.ui.classes,
        htmlFor: _heightWeightConfig.heightInches && "".concat(componentKey, ".").concat(_heightWeightConfig.heightInches.key)
      }, /*#__PURE__*/React.createElement("select", {
        className: touched && error ? 'error' : null,
        id: _heightWeightConfig.heightInches && "".concat(componentKey, ".").concat(_heightWeightConfig.heightInches.key),
        onChange: this.heightInchesChange
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, _heightWeightConfig.heightInches.placeholder || _heightWeightConfig.heightInches.label || 'Select'), _heightWeightConfig.heightInches && _heightWeightConfig.heightInches.items && _heightWeightConfig.heightInches.items.map(function (item) {
        return /*#__PURE__*/React.createElement("option", {
          key: item.key,
          value: item.value || item.key
        }, item.value || item.label);
      }))), heightFeetValue && heightInchesValue && /*#__PURE__*/React.createElement("div", {
        className: "col span_4_of_12 height-indicator"
      }, heightFeetValue, " foot : ", heightInchesValue, " inches")), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error-message"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "warn-message"
      }, warning)));
    }
  }]);
  return HeightSelectFields;
}(React.Component);

exports["default"] = HeightSelectFields;